import { BaSeIcon, BaSeParagraph } from '@base/react';
import React from 'react';
export const AccordionItem = ({
  title,
  children,
  inside = false,
  isOpen,
  onToggle,
  bgTitleColor,
  titleColor,
}) => {
  return (
    <div
      style={{
        border: '1px solid #ddd',
        borderRadius: '8px',
        marginBottom: '10px',
        overflow: 'hidden',
      }}
    >
      <div
        onClick={onToggle}
        style={{
          height: 'calc(70px - 1em',
          padding: '1em',
          backgroundColor: bgTitleColor ?? '#fff',
          color: titleColor,
          border: 'none',
          textAlign: 'left',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: '600',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          transition: 'all 0.2s ease',
        }}
      >
        <BaSeParagraph isBold={inside ? false : true} color={titleColor}>
          {title}
        </BaSeParagraph>

        <BaSeIcon
          color={titleColor}
          description="iconde de abrir e fechar accordion"
          name={isOpen ? `angle-up` : `angle-down`}
          size={30}
        />
      </div>

      <div
        style={{
          maxHeight: isOpen ? '1000px' : '0',
          overflow: 'hidden',
          transition: 'max-height 0.2s ease',
          backgroundColor: '#fff',
        }}
      >
        <div
          style={{
            padding: isOpen ? '16px 20px' : '0 20px',
            transition: 'padding 0.2s ease',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
